import React, { useEffect, useState } from "react";

import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./style.css";

const Switcher = props => {
  const {
    currentDetailId,
    deadlineListFilter,
    getNextDeadlines,
    isLoadingSubjective,
    setCurrentDeadlinesId
  } = props;

  const [currentCursor, setCurrentCursor] = useState(0);

  useEffect(() => {
    let index = deadlineListFilter && deadlineListFilter.length > 0
      ? deadlineListFilter
        .map(function(e) {
          return e.id;
        })
        .indexOf(currentDetailId)
      : 0;
    setCurrentCursor(index);
  },[]);

  useEffect(() => {
    if (isLoadingSubjective) return;
    let index =
      deadlineListFilter && deadlineListFilter.length > 0
        ? deadlineListFilter
          .map(function(e) {
            return e.id;
          })
          .indexOf(currentDetailId)
        : 0;
    if (!deadlineListFilter[index + 2]) {
      getNextDeadlines();
    }
  }, [deadlineListFilter]);

  const goBackDeadlines = cursorSwitch => {
    let moveCursor = currentCursor + cursorSwitch;
    if (deadlineListFilter.length > moveCursor) {
      setCurrentCursor(moveCursor);
      setCurrentDeadlinesId(deadlineListFilter[moveCursor].id);
    }
  };

  return (
    <div className="contentFooter">
      <div className="flexBtnContainer">
        {currentCursor > 0 ? (
          <Tooltip color={"rgb(0, 80, 117)"} placement="top" title={"Scadenza precedente"}>
            <div
              className="switcherBtn deadlinePrevBtn"
              onClick={() => goBackDeadlines(-1)}
            >
              <div>
                {" "}
                <FontAwesomeIcon icon={["far", "arrow-left"]} />{" "}
              </div>
            </div>
          </Tooltip>
        ) : (
          <div style={{ width: "48px", height: "48px" }} />
        )}

        {currentCursor < deadlineListFilter.length - 1 ? (
          <Tooltip color={"rgb(0, 80, 117)"} placement="top" title={"Scadenza successiva"}>
            <div
              className="switcherBtn deadlineNextBtn"
              onClick={() => goBackDeadlines(1)}
            >
              <div>
                {" "}
                <FontAwesomeIcon icon={["far", "arrow-right"]} />{" "}
              </div>
            </div>
          </Tooltip>
        ) : (
          <div style={{ width: "48px", height: "48px" }} />
        )}
      </div>
    </div>
  );
};

export default Switcher;
